export default __webpack_public_path__ + "static/media/margherita.1a87244f.jpg";